<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Contratistas</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Contratistas</h3>
    </div>
    

    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Contratista:</label>
          <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Contratista</mat-label>
                <input matInput type="text" placeholder="Contratista" [(ngModel)]="filter.contratista" maxlength="40">
              </mat-form-field>                    
          </div>
          <label class="col-md-2 control-label">RUC:</label>
          <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>RUC</mat-label>
                <input matInput type="text" placeholder="Contratista" [(ngModel)]="filter.ruc" maxlength="13" pattern="^[A-Za-z0-9]*$"
                (keypress)="keyPressNumberOnly($event)">
              </mat-form-field>                    
          </div>               
      </div>   
      <div class="form-group">
        <label class="col-md-2 control-label">Sedes:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Sedes</mat-label>
              <mat-select matSelect [(ngModel)]="filter.idSede">
                <mat-option *ngFor="let item of listaSedes; index as i;"
                  [value]='item.idSede'>{{item.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Compañía </mat-label>
              <mat-select matSelect [(ngModel)]="filter.companias" multiple>
                <mat-option *ngFor="let item of listaCompanias; index as i;"
                  [value]='item.idCompania'>{{item.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Estado:</label>
        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="filter.idEstado">
              <mat-option *ngFor="let item of listaEstados; index as i;"
                [value]='item.idParametroDetalle'>{{item.valor}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>
      </div>
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button [routerLink]="['/configuracion', 'contratistas', 'registrar']"><mat-icon>description</mat-icon> Nuevo contratista</a>
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <!-- <a class="btn btn-celeste" mat-raised-button [routerLink]="['/solicitudes-engie, 'exportar']">Exportar</a> -->
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="model.items"
          class="table table-striped table-vcenter"
        >
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element">
              {{ element.idContratista }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
          </ng-container>

          <ng-container matColumnDef="ruc">
            <th mat-header-cell *matHeaderCellDef>RUC</th>
            <td mat-cell *matCellDef="let element">{{ element.ruc }}</td>
          </ng-container>
      
          <ng-container matColumnDef="companias">
            <th mat-header-cell *matHeaderCellDef>Compañías</th>
            <td mat-cell *matCellDef="let element">{{ element.nombreCompanias }}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <a
                mat-icon-button
                color="primary"
                aria-label="Editar"
                [routerLink]="[
                  '/configuracion/',
                  'contratistas',
                  element.idContratista
                ]"
              >
                <!-- (click)="openDialog(element)" -->
                <mat-icon>create</mat-icon>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator
          #paginator
          [length]="resultsLength"
          [pageSize]="30"
          (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
